import { supabaseClient } from 'supabase'
import { requireStamp } from './deskDecisionError'

/** The five reject reasons 0035's `applications_desk_reject_reason` CHECK allows (D-10). */
export type DeskRejectReason = 'not_an_event' | 'wrong_area' | 'duplicate' | 'past' | 'other'

export type RejectCandidateParams = {
  id: number
  reason: DeskRejectReason
}

/**
 * Reject an undecided candidate with one reason (`desk_reject`, D-10). The RPC
 * stamps who decided and when; the client never sends either.
 *
 * Resolves with the `desk_decided_at` the RPC stamped, exactly as sent: the
 * toast's Undo hands it back to `desk_undo` (review AD-WR-11).
 *
 * Errors are thrown raw (so `mapDeskError` can read code and message); a
 * null result (already decided) throws DeskAlreadyDecidedError (D-11).
 */
export const rejectCandidate = async ({ id, reason }: RejectCandidateParams): Promise<string> => {
  const { data, error } = await supabaseClient.rpc('desk_reject', {
    p_id: id,
    p_reason: reason
  })

  if (error) {
    throw error
  }
  return requireStamp('desk_reject', data)
}
